import Reward from '@/models/loyaltyPanel/campaigns/Reward';
import _ from 'lodash';
import router from '../../../../routes';
const getDefaultState = () => ({
  rewards: [],
  systemNotifications: [],
  stores: [],
  paginationRewards: {},
  newReward: new Reward(),
  uploadingImage: null,
  coupons: [],
  couponsPagination: {},
  canGoToNextStep: false,
  step: 1,
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  getters: {
    rewards: (state) => state.rewards,
    systemNotifications: (state) => state.systemNotifications,
    campaignTypes: (state) => state.campaignTypes,
    stores: (state) => state.stores,
    paginationRewards: (state) => state.paginationRewards,
  },
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setRewards(state, payload) {
      state.rewards = payload;
    },
    setSystemNotifications(state, payload) {
      state.systemNotifications = payload;
    },
    setStores(state, payload) {
      state.stores = payload;
    },
    setPaginationRewards(state, payload) {
      state.paginationRewards = payload;
    },
    setNewReward(state, payload) {
      state.newReward = new Reward(payload);
    },
    setUploadingImage(state, payload) {
      state.uploadingImage = payload;
    },
    setCouponsPagination(state, payload) {
      state.couponsPagination = payload;
    },
    setCoupons(state, payload) {
      state.coupons = payload;
    },
    setCanGoToNextStep(state, payload) {
      state.canGoToNextStep = payload;
    },
    setStep(state, payload) {
      state.step = payload;
    },
  },

  actions: {
    async getRewards({ commit }, payload) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await Reward.getAll(payload);
        const { rewards, pagination } = data.data;

        commit('setRewards', rewards);
        commit('setPaginationRewards', pagination);
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });
        commit('setServerPagination', pagination, {
          root: true,
        });
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data);
      }
    },

    async getSystemNotifications({ commit }) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await Reward.getSystemNotifications();
        const systemNotifications = data.data;
        commit('setSystemNotifications', systemNotifications);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async getRewardById({ commit }, rewardId) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await Reward.getById(rewardId);
        commit('setLoading', false, { root: true });
        return data?.data?.reward || data?.data || data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        return null;
      }
    },

    async getStoresByIds({ commit, state }, ids) {
      try {
        commit('setLoading', true, { root: true });
        let stores = [];
        commit('setStores', stores);

        for (let id of ids) {
          let { data } = await Reward.getStore(id);
          stores.push(data.data.store);
        }

        commit('setStores', stores);

        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data);
      }
    },

    async sendTestMessage({ commit, state }, query) {
      try {
        commit('setLoading', true, { root: true });
        if (state.uploadingImage) {
          const fd = new FormData();
          fd.append('image', state.uploadingImage);
          const imageData = await Reward.uploadTestFile(fd);
          query.image_url = imageData.data.data.image_url;
        }
        await Reward.sendTestMessage(query);

        commit('setLoading', false, { root: true });
        return true;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data?.message,
          },
          { root: true }
        );
        return false;
      }
    },

    async getCoupons({ commit, state }, body) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await Reward.getCoupons();
        commit('setCoupons', data.data);
        // if(body.page == 1){
        //     commit("setCoupons", data.data.gifts);
        // }else{
        //     const coupons = state.coupons
        //     data.data.gifts.map(item => {
        //         coupons.push(item)
        //     })
        //     commit("setCoupons", coupons);
        // }

        // commit("setCouponsTotalPages", data.data.pagination.total_pages)
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data);
      }
    },

    async uploadImage({ commit, rootState }, { image, type }) {
      try {
        commit('setLoading', true, { root: true });

        const fd = new FormData();
        fd.append('image', image);
        const { data } = await Reward.uploadImage(fd, type);

        commit('setLoading', false, { root: true });
        commit('setDialog', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: `You have successfully uploaded the image!`,
          },

          { root: true }
        );
        commit('setLoading', false, { root: true });

        return data.data;
      } catch (ex) {
        commit('setLoading', false, { root: true });

        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data?.message,
          },
          { root: true }
        );
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
        commit('setLoading', false, { root: true });

        return false;
      }
    },

    async createReward({ commit, state }) {
      try {
        commit('setLoading', true, { root: true });

        const payload = { ...state.newReward };
        if (payload.coupon_claim_valid_days == null) delete payload.coupon_claim_valid_days;
        if (payload.reward_id == null) delete payload.reward_id;
        const { data } = await Reward.create(payload);

        if (data.message == 'REWARD_CREATED') {
          commit('setNewReward', new Reward());
          commit('setStep', 1);
          commit('setCanGoToNextStep', false);
          commit('setUploadingImage', null);
          commit('setLoading', false, { root: true });
          commit('setDialog', false, { root: true });
          commit(
            'setNotification',
            {
              show: true,
              type: 'success',
              text: 'You have successfully created reward!',
            },

            { root: true }
          );

          router.push('/en/loyaltyPanel/campaigns/view-rewards');
        }
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response.data.message,
          },

          { root: true }
        );
        setTimeout(() => commit('setNotification', { show: false }, { root: true }), 5000);
      }
    },

    async updateReward({ commit, state }) {
      try {
        commit('setLoading', true, { root: true });

        let rewardData = _.cloneDeep(state.newReward);
        if (rewardData.coupon_claim_valid_days == null) delete rewardData.coupon_claim_valid_days;

        const { data } = await Reward.update(rewardData);

        if (data.status == 'success') {
          let reward = state.rewards.find((x) => x.reward_id == rewardData.reward_id);
          reward = { ...data.data.reward };

          commit('setNewReward', new Reward());
          commit('setStep', 1);
          commit('setCanGoToNextStep', false);
          commit('setUploadingImage', null);
          commit('setDialog', false, { root: true });
          commit(
            'setNotification',
            {
              show: true,
              type: 'success',
              text: 'You have successfully created reward!',
            },

            { root: true }
          );

          router.push('/en/loyaltyPanel/campaigns/view-rewards');
        }
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response.data.message,
          },

          { root: true }
        );
        setTimeout(() => commit('setNotification', { show: false }, { root: true }), 5000);
      }
    },

    async deleteReward({ commit, state }, reward) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await Reward.delete(reward);

        if (data.message == 'REWARD_DELETED') {
          commit(
            'setRewards',
            state.rewards.filter((e) => e.reward_id != reward.reward_id)
          );

          commit('setDialog', false, { root: true });
          commit(
            'setNotification',
            {
              show: true,
              type: 'success',
              text: 'You have successfully deleted the reward!',
            },

            { root: true }
          );
        }
        commit('setLoading', false, { root: true });
        return true;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response.data.message,
          },

          { root: true }
        );
        setTimeout(() => commit('setNotification', { show: false }, { root: true }), 5000);
      }
    },
  },
};
